/* eslint-disable react-hooks/rules-of-hooks */
import { Unlock } from '@emotion-icons/octicons'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { ButtonWithIcon } from 'src/components/button/button-with-icon'
import { Colors, Shapes, Typographies, useTypography } from 'src/components/theme'
import PinsBg from 'src/assets/images/yellow-pins-bg.png'
import { UserTier } from 'src/common-services'
import { useLocationUnlocked } from 'src/hooks/use-location-unlocked'

const Wrapper = styled.div`
  display: flex;
  background-color: ${Colors.yellowLight};
  max-width: 100%;
  min-width: 100%;
  margin-inline: 0;
  background-position: right;
  background-size: contain;
  background-repeat: no-repeat;
`
const Content = styled.div`
  display: flex;
  width: 100%;
  max-width: 1130px;
  max-height: 120px;
  justify-content: space-between;
  margin-inline: auto;
  padding: ${Shapes.spacing[6]}px;
`

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[2]}px;
  max-width: 550px;
  height: 100%;
`
const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
const UnlockButton = styled(ButtonWithIcon)`
  padding: ${Shapes.spacing[2]}px ${Shapes.spacing[3]}px;
  ${useTypography(Typographies.title2)}
`
type UnlockedLocationProps = {
  tier?: UserTier
}
export const UnlockedLocation = (props: UnlockedLocationProps) => {
  const { tier } = props
  const unlocked = useLocationUnlocked(tier)

  if (!unlocked) {
    return null
  }

  return (
    <Wrapper
      style={{
        backgroundImage: `url(${PinsBg.src})`,
      }}>
      <Content>
        <LeftSide>
          <Typography variant="header3" color={Colors.neutral950}>
            This is a Free Unlocked Location
          </Typography>
          <Typography variant="textmdm" color={Colors.neutral700}>
            Get a full view of AlphaMap's powerful features through this free unlocked location. Sign up to experience
            firsthand how our tool can transform your workflow.
          </Typography>
        </LeftSide>
        <RightSide>
          <UnlockButton inverted>
            <Unlock size={16} />
            Unlock All Locations
          </UnlockButton>
        </RightSide>
      </Content>
    </Wrapper>
  )
}
